import { GroupedOption } from "types/quotes";

const FormatGroupLabel = (data: GroupedOption) => (
  <div>
    <span>{data.label}</span>
  </div>
);
export default FormatGroupLabel;
